import React from 'react';

function FreeCodeCampLogo(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      height={24}
      version='1.1'
      viewBox='0 0 210 24'
      width={210}
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <text
        x='0'
        y='18.5'
        fontFamily="'Segoe UI', Helvetica, Arial, sans-serif"
        fontSize='23'
        fontWeight='800'
        letterSpacing='1'
      >
        <tspan fill='#F7931E'>Jingga</tspan>
        <tspan fill='#ffffff'> Code</tspan>
      </text>
    </svg>
  );
}

FreeCodeCampLogo.displayName = 'FreeCodeCampLogo';

export default FreeCodeCampLogo;
